import React, { useEffect, useState , useContext} from "react";
import projectsService from "../../services/api/projects-service";
import UserContext from "../../UserContext";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";


const GenerateSsl = (props)=> {

  const domainId = props.domainId;
  const context = useContext(UserContext);
  const [formdetails, setFormDetails] = useState({domainId:domainId,verifyMethod:'EMAIL'});
  const [showLoader, setShowLoader]   = useState(false);
  const [showSaveButton, setShowSaveButton]   = useState(true);
  const [alert, setAlert]   = useState({show:false,message:'',type:''});


  const handleChange = (event) => {
    setFormDetails({
      ...formdetails,
      [event.target.name]: ( event.target.value ).trim(),
    });
  }
  
  const handleSubmit = function(e){  validateForm();e.preventDefault() }
 
  const validateForm = async () => {
    if(true){
      setShowLoader(true);
      setShowSaveButton(false);
      let generateSsl = await projectsService.generateSsl(formdetails);
      if(!generateSsl.status && generateSsl.error.errorCode === 403){
        context.setIsAuthorized(context);
      }
      else if(generateSsl.status){
        setTimeout(()=>{
          setShowLoader(false)
          setAlert({show:true,type:'success',message:'SSL generation request processed Successfully'});
        },1000);
        
        setTimeout(()=>{
          setAlert({show:false,type:'',message:''});
        },3000);

        setTimeout(()=>{
          props.setShowSSLVerify(false);
        },3000);

        

      }else{
        setTimeout(()=>{
          setShowLoader(false)
          setShowSaveButton(true)
          setAlert({show:true,type:'danger',message:'SSL generation could not be processed, Please try again.'});
        },1000);

        setTimeout(()=>{
          setAlert({show:false,type:'',message:''});
        },3000);
      }
    }
  }
  
    return (
      <div className="content">
        <Container>
          <Row>
          <Col className="ml-auto mr-auto"  md="12">
              <Card className="card-signup text-center">
                <CardHeader>
                  <CardTitle tag="h4">Generate SSL</CardTitle>
                </CardHeader>
                <CardBody>
                  <Form className="form-horizontol form" action="" id="generateSSl" method="POST" onSubmit={handleSubmit}>


                  <Row>
                      <Label sm="2">Verify SSL Via</Label>
                      <Col sm="7">
                      <div className="form-check-radio">
                          <Label check>
                            <Input
                              defaultChecked
                              defaultValue="EMAIL"
                              id="email"
                              name="verifyMethod"
                              type="radio"
                              onClick={handleChange}
                            />
                            Email <span className="form-check-sign" />
                          </Label>
                        </div>
                        <div className="form-check-radio">
                          <Label check>
                            <Input
                              defaultValue="DNS"
                              id="dns"
                              name="verifyMethod"
                              type="radio"
                              onClick={handleChange}
                            />
                            DNS <span className="form-check-sign" />
                          </Label>
                        </div>
                      </Col>
                  </Row>

                  {showSaveButton?<Button
                    className="btn-round"
                    color="info"
                    type="button"
                    onClick={validateForm}
                  >
                    Generate
                  </Button>:''}

                  {showSaveButton?<Button
                    className="btn-round"
                    color="danger"
                    type="button"
                    onClick={(event)=>  props.setShowSSLVerify(false) }
                  >
                    Back
                  </Button>:''}
                  {alert.show?<Alert color={alert.type}>
                    {alert.message}
                  </Alert>:''}

                  {showLoader?<Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>:''}
                    
                  </Form>
                </CardBody>
                <CardFooter>
                  
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("../../assets/img/bg/jan-sendereks.jpg")})`,
          }}
        />
      </div>
    );
  
}

export default GenerateSsl;
